import { useState, useRef, useEffect } from 'react';

import { get as _get } from 'lodash';

import { PaymentScreenTypes } from '../../Payment/Utils/PaymentTypes';

function useMyPlanExtrasModal({
  Config,
  addExtraPlanData,
  onPressAddConfirmation,
  onSelectDefaultCard = () => {},
  onPressSaveCard = () => {},
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [saveCardIsLoading, setSaveCardIsLoading] = useState(false);
  const [extraModalJson, setExtraModalJson] = useState({
    ..._get(addExtraPlanData, '["data"]', {}),
    ..._get(Config, '["data"]'),
  });
  const [isLoadingSuccessful, setIsLoadingSuccessful] = useState(true);
  const [doneLoadingSubtitlePlaceholders, setDoneLoadingSubtitlePlaceholders] = useState(
    _get(extraModalJson, 'resultScreen.messagePlaceholders', []),
  );
  const [isResetData, setIsResetData] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState({
    isCardListOpend: false,
    title: undefined,
  });
  let loadingPromise = useRef().current;
  const extraPlanType = useRef();
  const [loadingFailureError, setLoadingFailureError] = useState({});
  useEffect(() => {
    setExtraModalJson(prevExtraModalJson => ({
      ...prevExtraModalJson,
      ..._get(addExtraPlanData, `[${extraPlanType.current}]`, {}),
    }));
  }, [addExtraPlanData]);
  const resetModalStatus = () => {
    loadingPromise && loadingPromise.cancel();
    setIsLoading(false);
    setDoneLoadingSubtitlePlaceholders(
      _get(extraModalJson, 'resultScreen.messagePlaceholders', []),
    );
  };
  const toggleModal = () => {
    resetModalStatus();
    setIsVisible(!isVisible);
    setTimeout(() => {
      setIsResetData(!!isVisible);
      setPaymentOptions({
        isCardListOpend: false,
        title: undefined,
      });
    }, 200);
  };
  const closeModal = () => {
    resetModalStatus();
    setIsVisible(false);
    setTimeout(() => {
      setIsResetData(true);
      setPaymentOptions({
        isCardListOpend: false,
        title: undefined,
      });
    }, 200);
  };
  const handlePaymentFooterIconPress = () => {};
  const handleConfirmButtonPress = (paymentTypeOptionSelected, paymentAmountOptionSelected) => {
    setIsLoading(true);
    loadingPromise = Promise.resolve(
      onPressAddConfirmation(paymentTypeOptionSelected, paymentAmountOptionSelected),
    )
      .then(placeHolder => {
        setDoneLoadingSubtitlePlaceholders([placeHolder || paymentAmountOptionSelected.title]);
        setIsLoading(false);
        setIsLoadingSuccessful(true);
      })
      .catch(error => {
        setLoadingFailureError(error);
        setIsLoading(false);
        setIsLoadingSuccessful(false);
      });
  };
  const handleSelectDefaultCard = card => {
    onSelectDefaultCard(card);
    setPaymentOptions({
      ...paymentOptions,
      isCardListOpend: false,
    });
  };
  const onPressOpenCardList = () => {
    setPaymentOptions({
      ...paymentOptions,
      isCardListOpend: !paymentOptions.isCardListOpend,
    });
  };
  const onPressAddCard = () => {
    setPaymentOptions({
      ...paymentOptions,
      screen: PaymentScreenTypes.ADD_PAYMENT_CARD,
      title: 'quick_action_add_new_payment_card_title',
      isBackButton: true,
    });
  };
  const handlePressSaveNewCard = cardData => {
    setSaveCardIsLoading(true);
    setPaymentOptions({
      isBackButton: false,
      title: 'quick_action_add_new_payment_card_title',
    });
    onPressSaveCard(cardData)
      .then(res => {
        setSaveCardIsLoading(false);
        setPaymentOptions({
          ...paymentOptions,
          screen: undefined,
          isCardListOpend: false,
          title: undefined,
          isBackButton: false,
        });
      })
      .catch(err => {
        setPaymentOptions({
          ...paymentOptions,
          screen: undefined,
          isCardListOpend: false,
          title: undefined,
          isBackButton: false,
        });
        setLoadingFailureError(err);
        setSaveCardIsLoading(false);
      });
  };
  const onBackButtonPress = () => {
    setPaymentOptions({
      ...paymentOptions,
      isBackButton: false,
      title: undefined,
      screen: undefined,
    });
  };

  const toggleAddUsageModal = key => {
    extraPlanType.current = key;
    // spreading config of data first to fall back on data config if config of item was not provided
    setExtraModalJson({
      ..._get(Config, '["data"]', {}),
      ..._get(addExtraPlanData, `[${key}]`, {}),
      ..._get(Config, `[${key}]`, {}),
    });
    toggleModal();
  };

  return {
    toggleModal,
    isVisible,
    closeModal,
    isLoading,
    saveCardIsLoading,
    extraModalJson,
    handlePaymentFooterIconPress,
    handleConfirmButtonPress,
    isLoadingSuccessful,
    doneLoadingSubtitlePlaceholders,
    isResetData,
    handleSelectDefaultCard,
    onPressOpenCardList,
    paymentOptions,
    setPaymentOptions,
    onPressAddCard,
    handlePressSaveNewCard,
    onBackButtonPress,
    loadingFailureError,
    toggleAddUsageModal,
  };
}

export { useMyPlanExtrasModal };
export default useMyPlanExtrasModal;
